<div class="row mt-5" *ngIf="commonDentalPlanSavings" role="region" aria-label="Common Dental Plan Savings">
  <div class="col-12">
    <app-card-container>
      <div class="row">
        <div class="col-12">
          <div class="header-text" id="cdps-heading">Common Dental Plan Savings</div>
        </div>
      </div>
      <div class="table-scroll-wrapper">
        <div class="table-content">
          <div class="row mt-5 mb-3" role="row">
            <div class="table-title" role="columnheader" [ngClass]="getCdpsColumnClass()" *ngIf="getShowAdaCode()">ADA Code</div>
            <div class="table-title" role="columnheader" [ngClass]="getCdpsColumnClass()">Procedure Description</div>
            <div class="table-title" role="columnheader" [ngClass]="getCdpsColumnClass()">{{ getMemberColumnLabel() }}</div>
            <div class="col-12 border-gray mt-2"></div>
          </div>
          <div *ngFor="let group of commonDentalPlanSavings?.groups" role="rowgroup">
            <ng-container *ngIf="group.itemName !== FOOTER_GROUP">
              <div class="row">
                <div class="col-12 section-header mt-3 mb-2">{{ group.itemName }}</div>
              </div>
              <div class="row mt-2" role="row" *ngFor="let item of group.items">
                <div class="mb-3" role="cell" [ngClass]="getCdpsColumnClass()" *ngIf="getShowAdaCode()">{{ item.adaCode }}</div>
                <div class="mb-3" role="cell" [ngClass]="getCdpsColumnClass()">{{ item.description }}</div>
                <div class="mb-3" role="cell" [ngClass]="getCdpsColumnClass()">{{ item.memberPays }}</div>
                <div class="col-12 border-gray"></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row mt-5 mb-3">
        <div class="col-12 col-lg-12 mb-3 sub-text2" *ngIf="footer !== DEFAULT_FOOTER" role="note">*Member savings may vary by location. {{ getXrayExamStatement() }} Any services not listed are available at a minimum of {{ footer }} off the office's Retail Fee(s).</div>
        <div class="col-12 col-lg-12 mb-3 sub-text">You are responsible for payment of the dentist's normal fees for any of the following limited services:</div>
        <div class="col-12 col-lg-12 mb-3 sub-text2">
          Replacement of partial dentures is limited to one per arch every two years. <br />
          Replacement of full upper and lower dentures are limited to one per arch every two years. <br />
          Replacement of fixed prosthetics such as crowns, bridges, inlays, and onlays is limited to once every year.
        </div>
      </div>
    </app-card-container>
  </div>
</div>
